export default "__VITE_ASSET__g_MXS6JV__"